import React from 'react'

export interface CaptionsIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number
    strokeWidth?: number
}

// lucide's `captions` (a screen with two lines of text), drawn here because
// the installed lucide-react predates it. Same props as a lucide icon so it
// drops into the video settings menu beside them.
export default function CaptionsIcon({
    size = 24,
    strokeWidth = 2,
    className,
    ...props
}: CaptionsIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <rect width="18" height="14" x="3" y="5" rx="2" ry="2" />
            <path d="M7 15h4M15 15h2M7 11h2M13 11h4" />
        </svg>
    )
}
